import React from 'react';
import { Col, Layout, message, Row, Select,  Checkbox, InputNumber,Icon } from 'antd';
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from 'js-export-excel';
import moment from "moment";
const { Content } = Layout;
const { Option } = Select;
class ComplianceLicenseExpiration extends React.Component {
    columns = [{
        title: 'License Number',
        dataIndex: 'license_No',
        sorter: (a, b) => a.license_No.localeCompare(b.license_No),
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Document Name',
        dataIndex: 'docName',
        sorter: (a, b) => a.docName.localeCompare(b.docName),
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Submit Date',
        dataIndex: 'submit_Date',
        sorter: (a, b) => new Date(a.submit_Date) - new Date(b.submit_Date),
        render: (text, record) =>
            record["submit_Date"] !== null && record["submit_Date"] !== ""
                ? moment(record["submit_Date"]).format("MM/DD/YYYY")
                : "",
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Date Approved',
        dataIndex: 'date_Approved',
        sorter: (a, b) => new Date(a.date_Approved) - new Date(b.date_Approved),
        render: (text, record) =>
            record["date_Approved"] !== null && record["date_Approved"] !== ""
                ? moment(record["date_Approved"]).format("MM/DD/YYYY")
                : "",
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Effective Date',
        dataIndex: 'effective_Date',
        sorter: (a, b) => new Date(a.effective_Date) - new Date(b.effective_Date),
        render: (text, record) =>
            record["effective_Date"] !== null && record["effective_Date"] !== ""
                ? moment(record["effective_Date"]).format("MM/DD/YYYY")
                : "",
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Termination Date',
        dataIndex: 'termination_Date',
        sorter: (a, b) => new Date(a.termination_Date) - new Date(b.termination_Date),
        render: (text, record) =>
            record["termination_Date"] !== null && record["termination_Date"] !== ""
                ? moment(record["termination_Date"]).format("MM/DD/YYYY")
                : "",
        sortDirections: ["descend", "ascend"]
    },
    ];
    constructor(props) {
        super(props);
        this.state = {
            agencies: null,
            compliancelicenseexpiration: null,
            isLoading: false,
            brokers: null,
            user_id: 0,
            experyval: "7",
            items:[],
            name: '',
            isCoustom:false
        }
        this.tableButtons = [{
            buttonType: "primary",
            content: "Export Excel",
            clickHandler: () => {
                this.downloadExcel();
            }
        }];
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    downloadExcel = () => {
        const data = this.state.compliancelicenseexpiration ? this.state.compliancelicenseexpiration : '';//tabular data
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'License Number': data[i].license_No,
                        'Document Name': data[i].docName,
                        'Submit Date': data[i].submit_Date!==null&&data[i].submit_Date!==""?moment(data[i].submit_Date).format("MM/DD/YYYY"):null,
                        'Date Approved': data[i].date_Approved!==null&&data[i].date_Approved!==""?moment(data[i].date_Approved).format("MM/DD/YYYY"):null,
                        'Effective Date': data[i].effective_Date!==null&&data[i].effective_Date!==""?moment(data[i].effective_Date).format("MM/DD/YYYY"):null,
                        'Termination Date': data[i].termination_Date!==null&&data[i].termination_Date!==""?moment(data[i].termination_Date).format("MM/DD/YYYY"):null,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'ComplianceLicenseExpirationReport'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['License Number', 'Document Name', 'Submit Date', 'Date Approved', 'Effective Date', 'Termination Date'],
                sheetHeader: ['License Number', 'Document Name', 'Submit Date', 'Date Approved', 'Effective Date', 'Termination Date'],
            }
        ];
        if (dataTable.length > 0) {
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
    componentDidMount = () => {
        this.getClientMasters();
    }
    onChange = (type, e) => {
        if (type === "user") {
            this.setState({
                user_id: e
            })
        }
        if (type === "exp") {
            this.setState({
                experyval: e
            })
        }
        setTimeout(() => {
            if (this.state.user_id &&  this.state.experyval) {
                this.GetComplianceLicenseExpiry(this.state.user_id,this.state.experyval);
            }
            if (this.props.type === "bsu" && this.state.experyval) {
                this.GetComplianceLicenseExpiry(0,this.state.experyval);
            }
        }, 100);
    }
    GetComplianceLicenseExpiry(id, expiryvalue) {
        this.setState({
            isLoading: true
        })
        this.api.invoke(
            "GetLicenceExpiry/" + id + "/" + this.props.user_Type + "/" + expiryvalue,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            isLoading: false,
                            compliancelicenseexpiration: data.data
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            });
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        agencies: data.agencies,
                        brokers: data.brokers,
                    });
                    if (this.props.type !== "bsu") {
                        if (this.props.user_Type === "B") {
                            this.setState({
                                user_id:  data.brokers[0]?data.brokers[0].id:null
                            })
                            if(data.brokers[0])
                            this.GetComplianceLicenseExpiry(data.brokers[0]?data.brokers[0].id:null,this.state.experyval);
                        } else {
                            this.setState({
                                user_id: data.agencies[0]?data.agencies[0].id:null
                            })
                            if(data.agencies[0])
                            this.GetComplianceLicenseExpiry(data.agencies[0]?data.agencies[0].id:null,this.state.experyval);
                        }
                    } else {
                        this.setState({
                            user_id: 0
                        })
                        this.GetComplianceLicenseExpiry(0,this.state.experyval);
                    }
                }
            },
            ["ALLAGENCY", "ADMINBROKER"]
        );
    }
    onChangeche=()=>{
        this.setState({
            isCoustom:!this.state.isCoustom
        })
    }
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        const { title, user_Type } = this.props;
        return (
            <Content>
                <div className="mi_main_div">
                    <Row style={{ padding: '20px', background: 'white' }}>
                        <Col span={24}>
                            <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '60px' }}> {title}	</p>
                        </Col>
                        <Col span={24} style={{ marginBottom: '40px' }}>
                            <Row span={24}>
                                {role !== "broker"&&role !== "agency" ? user_Type === "A" ?
                                    this.state.agencies ?
                                        <Col span={12} style={{ padding: '0px 20px 0px 0px' }} >
                                            <h3><b>Agency : </b></h3>
                                            <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                                onChange={this.onChange.bind(this, 'user')}
                                                placeholder="Please Select"
                                                showSearch={true}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                defaultValue={this.state.agencies[0]?this.state.agencies[0].id:undefined}
                                            >
                                                {this.state.agencies ? this.state.agencies.map((tag) => (
                                                    <Option value={tag.id} key={tag.id}>
                                                        {tag.name}
                                                    </Option>
                                                )) : ''}
                                            </Select>
                                        </Col> : '' : this.state.brokers ? <Col span={12} style={{ padding: '0px 20px 0px 0px' }}>
                                            <h3><b>Broker : </b></h3>
                                            <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                                onChange={this.onChange.bind(this, 'user')}
                                                placeholder="Please Select"
                                                showSearch={true}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                defaultValue={this.state.brokers[0]?this.state.brokers[0].id:undefined}
                                            >
                                                {this.state.brokers ? this.state.brokers.map((tag) => (
                                                    <Option value={tag.id} key={tag.id}>
                                                        {tag.name}
                                                    </Option>
                                                )) : ''}
                                            </Select>
                                        </Col> : '' : ''}
                                <Col span={12} style={{ padding: '0px 20px' }}>
                                    <h3><b>Expiration  : </b> <Checkbox onChange={this.onChangeche}>Custom</Checkbox></h3>
                                    {this.state.isCoustom?<InputNumber className="mi_input_profile" onChange={this.onChange.bind(this, 'exp')}/>:
                                    <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                        onChange={this.onChange.bind(this, 'exp')}
                                        placeholder="Please Select"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        defaultValue={this.state.experyval?this.state.experyval:undefined}
                                    >
                                        <Option value="7" key="7">1 Week</Option>
                                        <Option value="15" key="15">15 Days</Option>
                                        <Option value="30" key="30">30 Days</Option>
                                        <Option value="60" key="60">60 Days</Option>
                                    </Select>
                                   }
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <ReportTableWrapper rowKey="name" columns={this.columns} data={this.state.compliancelicenseexpiration ? this.state.compliancelicenseexpiration : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default ComplianceLicenseExpiration;